export enum ErrorType{
    UnProcessable
}

export class CustomError extends Error{

    errorType: ErrorType;
    Count: number;
}


// WEBPACK FOOTER //
// D:/a/1/s/src/app/Shared/model/ErrorType.ts